import type { SalesMoveBucket } from "@sales-ops-amplify/shared";
import { SALES_MOVE_BUCKET_LABELS } from "@sales-ops-amplify/shared";
import { cn } from "@/cn";

const BUCKETS: Array<SalesMoveBucket | "ALL_ACTIVE"> = [
  "ACT_NOW",
  "REPLY_NEEDED",
  "READY_TO_ADVANCE",
  "AT_RISK",
  "WAITING",
  "NURTURE",
  "ALL_ACTIVE",
];

type Props = {
  value: SalesMoveBucket | "ALL_ACTIVE";
  counts: Record<SalesMoveBucket | "ALL_ACTIVE", number>;
  onChange: (bucket: SalesMoveBucket | "ALL_ACTIVE") => void;
};

export function SalesMoveBucketSelector({ value, counts, onChange }: Props) {
  return (
    <div className="mb-4 flex gap-1.5 overflow-x-auto pb-1">
      {BUCKETS.map((bucket) => {
        const active = value === bucket;
        const count = counts[bucket] ?? 0;
        return (
          <button
            key={bucket}
            type="button"
            onClick={() => onChange(bucket)}
            className={cn(
              "shrink-0 rounded-md px-2.5 py-1.5 text-xs font-medium transition",
              active
                ? "bg-foreground text-background"
                : "bg-muted/30 text-muted-foreground hover:bg-muted/50 hover:text-foreground",
            )}
          >
            {SALES_MOVE_BUCKET_LABELS[bucket]}
            <span className={cn("ml-1.5 tabular-nums", active ? "opacity-80" : "opacity-60")}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
